import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/compatibility-report")({
  head: () =>
    pageHead("Build a Compatibility Reading", {
      canonicalPath: "/compatibility-report",
      robots: "noindex, nofollow",
    }),
});
